import { del, get, post, put } from '@aiptyg/api-client';
import type {
  AdminNotificationDTO,
  AdminNotificationListResponseDTO,
  NotificationCategory,
  UpsertAdminNotificationRequest,
} from '../types/notifications.types';

export function listNotifications(params: {
  page: number;
  pageSize: number;
  marketId?: string;
  category: '' | NotificationCategory;
}): Promise<AdminNotificationListResponseDTO> {
  const qs = new URLSearchParams();
  qs.set('page', String(params.page));
  qs.set('page_size', String(params.pageSize));
  if (params.category) {
    qs.set('category', params.category);
  }
  if (params.marketId) {
    qs.set('market_id', params.marketId);
  }
  return get<AdminNotificationListResponseDTO>(`/v1/admin/notifications?${qs.toString()}`);
}

export function getNotification(id: number): Promise<AdminNotificationDTO> {
  return get<AdminNotificationDTO>(`/v1/admin/notifications/${id}`);
}

export function createNotification(
  data: UpsertAdminNotificationRequest,
): Promise<AdminNotificationDTO> {
  const body: Record<string, unknown> = { ...data };
  return post<AdminNotificationDTO>('/v1/admin/notifications', body);
}

export function updateNotification(
  id: number,
  data: UpsertAdminNotificationRequest,
): Promise<AdminNotificationDTO> {
  const body: Record<string, unknown> = { ...data };
  return put<AdminNotificationDTO>(`/v1/admin/notifications/${id}`, body);
}

export function deleteNotification(id: number): Promise<{ deleted: boolean }> {
  return del<{ deleted: boolean }>(`/v1/admin/notifications/${id}`);
}
